import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VuePnP from 'vue-pnpjs'
import {sp} from '@pnp/sp'
import {graph} from '@pnp/graph'

Vue.use(VuePnP, {
  sp,
  graph
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
